<template lang="html">

  <section class="wrapper contacto">

    <div class="encabezado" data="contacto"></div>
    <nav class="migas">
      <div class="container row-start">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
      </div>
    </nav>

    <div class="content">

      <h1>Podemos ayudarte</h1>

      <div class="texto-intro container">
        <p>Para cualquier solicitud de información referente a nuestros servicios de prácticas, ya seas titulado o empresa, no dudes en contactar con nosotros a través de este formulario. Nos pondremos en contacto a la mayor brevedad. </p>
        <p>Gracias por tu confianza.</p>
      </div>


      <formulario></formulario>

    </div>
  </section>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/contacto/formulario'

  export default {
    name: 'contacto',
    components: {
      formulario
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/views/contacto.vue